import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProfileComponent } from './components/profile/profile.component';
import { LoginComponent } from './components/onboarding/login/login.component';
import {ResetPasswordComponent } from './components/onboarding/reset-password/reset-password.component';
import {HeaderItem} from './components/shared/header-item';
import {AccessControl} from './services/access-control';
import {RegistrationComponent} from './components/onboarding/registration/registration.component';
import {HazardsComponent} from './components/hazards/hazards.component';
import {HazardsResolver} from './resolvers/hazards-resolver';
import {HazardsMapComponent} from './components/hazards/hazards-map/hazards-map.component';
import {HazardsListComponent} from './components/hazards/hazards-list/hazards-list.component';
import {MapModalComponent} from './components/modals/map-modal/map-modal.component';
import {NewsModalComponent} from './components/modals/news-modal/news-modal.component';
import {ProfileResolver} from './components/profile/profile-resolver';

const routes: Routes = [

  { path: '', redirectTo: 'hazards', pathMatch: 'full' },
  {
    path: 'hazards',
    component: HazardsComponent,
    canActivate: [/*AccessControl*/],
    // children: [{ path: '', component: HazardsComponent, outlet: 'hazards', resolve: {data: HazardsResolver}}]
    children: [
      { path: '', redirectTo: 'map', pathMatch: 'full' },
      { path: 'map', component: HazardsMapComponent },
      { path: 'list', component: HazardsListComponent }
    ]
  },
  { path: 'profile', component: ProfileComponent, resolve: {data: ProfileResolver} },
  { path: 'registration', component: RegistrationComponent},
  { path: 'login', component: LoginComponent},
  { path: 'reset-password', component: ResetPasswordComponent},

  { path: 'map-modal/:hazard-id', component: MapModalComponent, outlet: 'modal'},
  { path: '**', redirectTo: 'hazards'}
  // { path: 'news-modal/:hazard-id', component: NewsModalComponent, outlet: 'modal'},
];

@NgModule({
  exports: [ RouterModule ],
  imports: [ RouterModule.forRoot(routes, { enableTracing: false }) ],
  providers: [HazardsResolver, ProfileResolver]
})

export class AppRoutingModule
{
  getHeaderItems()
  {
    return [];
    // return [new HeaderItem('Monitoring', '', [])];

    // const subItems = [new HeaderItem('sub1', 'sub1Path', []), new HeaderItem('sub2', 'sub2Path', [])];
    //return [
      // new HeaderItem('Monitoring', '', []),
      //new HeaderItem('Profile', '/profile', [])];
  }
}
